var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Image(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 624,
    height: 618,
    viewBox: "0 0 624 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.654 321.582C161.307 331.222 162.934 342.454 164.573 353.74C167.612 374.698 170.683 395.838 186.773 407.382C208.122 422.66 237.413 410.685 261.542 400.421C285.671 390.158 318.907 384.413 333.768 406.016C339.986 415.118 340.73 426.35 341.473 437.571C341.743 441.659 342.012 445.737 342.54 449.707C348.144 492.139 390.648 526.19 433.335 522.543C476.032 518.896 512.091 478.12 510.389 435.355C510.033 426.21 508.298 416.678 506.563 407.189C502.532 385.133 498.534 363.261 512.091 346.801C521.187 335.719 535.283 331.48 549.379 327.252C554.832 325.617 560.296 323.971 565.458 321.937C602.886 307.198 627.888 265.788 623.502 225.841C619.116 185.894 585.729 150.907 545.963 144.581C530.584 142.118 515.044 143.581 499.461 145.044C487.596 146.163 475.698 147.282 463.833 146.669C436.395 145.259 405.498 128.863 403.882 101.515C403.375 92.983 405.843 84.6881 408.311 76.4039C410.822 67.9692 413.333 59.5344 412.697 50.8629C411.232 30.8626 393.396 15.6822 374.828 8.0436C335.492 -8.1589 287.051 0.652419 255.96 29.6469C236.367 47.8828 224.319 72.0252 212.249 96.2213C206.925 106.883 201.602 117.556 195.62 127.733C178.453 156.975 149.927 184.636 117.403 186.626C117.101 186.777 116.81 186.927 116.519 187.067C115.635 187.508 114.762 187.939 113.9 188.369L39.2602 203.087C16.9846 207.498 0.69008 226.702 0.0219195 249.381C-0.689348 273.179 15.9823 293.997 39.3895 298.559L157.654 321.582Z",
    fill: "#B1EDB9",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.635 617.675C277.679 617.675 342.568 609.417 342.568 599.229C342.568 589.042 277.679 580.783 197.635 580.783C117.591 580.783 52.7026 589.042 52.7026 599.229C52.7026 609.417 117.591 617.675 197.635 617.675Z",
    fill: "#B1EDB9",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.324 400.541L199.216 585",
    stroke: "url(#paint0_linear_312_54676)",
    strokeWidth: 24.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.108 433.217C219.23 433.217 237.162 415.285 237.162 393.162C237.162 371.04 219.23 353.108 197.108 353.108C174.986 353.108 157.054 371.04 157.054 393.162C157.054 415.285 174.986 433.217 197.108 433.217Z",
    fill: "url(#paint1_radial_312_54676)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0183 265.68C38.6409 257.142 44.1302 249.409 52.4344 246.831L139.121 237.162L140.189 285.649L55.3679 283.397C46.3195 282.157 39.4497 274.696 39.0183 265.68Z",
    fill: "#B9EDC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.27 317.271H171.811V364.703H200.27V317.271Z",
    fill: "url(#paint2_linear_312_54676)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.406 317.271H200.271V364.703H222.406V317.271Z",
    fill: "url(#paint3_linear_312_54676)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.479 262.89C85.5755 243.098 97.955 225.17 116.54 219.266L224.815 199.216L226.622 313.054L123.069 304.068C102.784 301.03 87.4362 283.748 86.479 262.89Z",
    fill: "url(#paint4_linear_312_54676)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.923 263.175C103.021 242.199 115.378 223.176 133.929 216.932L197.108 204.486L116.484 219.378C97.9328 225.258 85.5868 243.111 86.4779 262.821C87.3797 283.592 102.753 300.802 123.054 303.827L132.222 304.621C116.162 298.366 104.718 282.165 103.912 263.196L103.923 263.175Z",
    fill: "url(#paint5_linear_312_54676)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.246 260.784C139.126 230.339 154.658 202.713 178.011 193.652L314.108 160.216V341.513L186.261 324.179C160.679 319.535 141.431 292.935 140.257 260.773L140.246 260.784Z",
    fill: "url(#paint6_linear_312_54676)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M324.649 341.513C374.714 341.513 415.297 300.93 415.297 250.864C415.297 200.799 374.714 160.216 324.649 160.216C274.583 160.216 234 200.799 234 250.864C234 300.93 274.583 341.513 324.649 341.513Z",
    fill: "url(#paint7_linear_312_54676)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M324.122 328.865C367.494 328.865 402.649 293.71 402.649 250.338C402.649 206.965 367.494 171.811 324.122 171.811C280.749 171.811 245.595 206.965 245.595 250.338C245.595 293.71 280.749 328.865 324.122 328.865Z",
    fill: "url(#paint8_linear_312_54676)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M324.649 291.973C366.559 291.973 400.541 273.571 400.541 250.865C400.541 228.159 366.559 209.757 324.649 209.757C282.739 209.757 248.757 228.159 248.757 250.865C248.757 273.571 282.739 291.973 324.649 291.973Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M324.649 285.649C343.856 285.649 359.432 270.072 359.432 250.865C359.432 231.658 343.856 216.081 324.649 216.081C305.442 216.081 289.865 231.658 289.865 250.865C289.865 270.072 305.442 285.649 324.649 285.649Z",
    fill: "url(#paint9_radial_312_54676)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.018 279.314C391.92 271.972 400.541 261.775 400.541 250.513C400.541 239.251 392.45 229.693 379.292 222.405C383.008 230.695 385.072 239.869 385.072 249.522C385.072 260.22 382.533 270.342 378.018 279.324V279.314ZM249.178 254.828C249.038 253.081 248.973 251.302 248.973 249.522C248.973 248.734 248.984 247.945 249.016 247.167C248.843 248.276 248.757 249.394 248.757 250.524C248.757 251.983 248.897 253.422 249.178 254.839V254.828Z",
    fill: "#DEEDE0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.406 390L104.352 594.486",
    stroke: "url(#paint10_linear_312_54676)",
    strokeWidth: 24.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M216.081 390L289.865 594.486",
    stroke: "url(#paint11_linear_312_54676)",
    strokeWidth: 24.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_54676",
    x1: 199.48,
    y1: 400.552,
    x2: 200.992,
    y2: 568.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2EDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5EDCB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_312_54676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.738 440.877) rotate(-90) scale(41.3648)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DED8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98EAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_54676",
    x1: 186.046,
    y1: 317.271,
    x2: 186.046,
    y2: 364.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE07E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_312_54676",
    x1: 211.328,
    y1: 317.271,
    x2: 211.328,
    y2: 364.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71E580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88ED95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_312_54676",
    x1: 156.529,
    y1: 199.216,
    x2: 156.529,
    y2: 313.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95EDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CED6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_312_54676",
    x1: 141.777,
    y1: 204.476,
    x2: 141.777,
    y2: 304.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88ED95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51D161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_312_54676",
    x1: 227.139,
    y1: 160.216,
    x2: 227.139,
    y2: 341.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8EDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98EAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_312_54676",
    x1: 249.972,
    y1: 170.497,
    x2: 391.442,
    y2: 322.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EDD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2EAC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_312_54676",
    x1: 392.903,
    y1: 255.641,
    x2: 225.629,
    y2: 242.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3EDD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFEDB7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_312_54676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.76 227.685) rotate(150.58) scale(58.1274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#74ED84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68DC77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_312_54676",
    x1: 143.879,
    y1: 390,
    x2: 143.879,
    y2: 594.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98EAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8EBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_312_54676",
    x1: 234.787,
    y1: 393.283,
    x2: 274.306,
    y2: 611.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98EAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4EDBB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Image);
export default __webpack_public_path__ + "static/media/404-image.3d6a51bacb4d1fc6b6e67e24cd45e40f.svg";
export { ForwardRef as ReactComponent };